module.exports = __webpack_public_path__ + "static/NBANH_horizontal-fdd21d488a5d995af560f6e8332f92e6.png";